import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Carrier } from 'src/app/management/model/carrier';
import { CarrierService } from 'src/app/management/service/carrier.service';

@Component({
  selector: 'app-carrier-selector',
  templateUrl: './carrier-selector.component.html',
  styleUrls: ['./carrier-selector.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CarrierSelectorComponent),
      multi: true
    }
  ]
})
export class CarrierSelectorComponent implements OnInit, ControlValueAccessor {
  @Input()
  type: 'id' | 'name' = 'id';
  @Input()
  setDefaultOnInit: boolean = false;
  @Output()
  readonly selected: EventEmitter<string | number> = new EventEmitter();

  value: string | number | null = null;
  availableCarriers: Carrier[] = [];
  disabled: boolean = false;

  onChange: any = () => { };
  onTouched: any = () => { };

  constructor(private carrierService: CarrierService) { }

  ngOnInit(): void {
    this.carrierService.fetchCarriers().subscribe(c => {
      this.availableCarriers = c ?? [];
      if (this.availableCarriers.length === 1 && this.setDefaultOnInit) {
        this.onSelectChange(this.getOptionValue(this.availableCarriers[0]));
        this.disabled = true;
      }
    });
  }

  getOptionValue(item: Carrier): any {
    return this.type ? item[this.type] : item;
  }

  writeValue(value: string | number | null): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelectChange(value: any): void {
    this.value = value;
    this.onChange(value);
    this.selected.next(value);
  }

}
